<template>
  <div class="list">
    <div v-for="(item ,index) in list" :key="index" class="list-item">
      <div @click="toDetail(item.id)" class="list-item-pic">
        <img :src="item.img">
      </div>
      <div class="more">点击查看设计理念</div>
      <div class="content">
        <span class="cc">{{ item.name }}</span>
        <span class="praise"><span >{{ item.praise }}</span><span style="color:#2F1F14;">票</span></span>
      </div>
      <div class="votebtn">
        <button @click="toVote(item.id)">为他投票</button>
      </div>  
    </div>
  </div>
</template>

<script>
import { toVote } from '@/http/index';
export default {
  props: ['list'],
  methods: {
    toDetail(id){
      this.$router.push({path: '/userdetail', query: { id }})
    },
    toVote(id){
      let params = {
        source: 2,
        token: localStorage.getItem('qingdao_cultural_vote_token'),
        id: id
      }
      toVote(params).then(res => {
        if(res.errCode == "100"){ this.$emit('logout') }
        else { 
          this.alertModelMsg(res.message)
          this.$emit('toQueryVote')
        } 
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  position: relative;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  .list-item {
    width: 47.0666667vw;
    height: 53.3333333vw;
    background: white;
    margin-bottom: 3.4666666667vw;
    border-radius: 6px;
    overflow: hidden;
    .content {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 7.8vw;
      line-height: 7.8vw;
      .cc {
        width: 47%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #2F1F14;
        font-weight: 500;
      }
      .praise {
        color: #FF8D39;
        font-size: 14px;
      }
    }
    .more {
      color:#bbb
      ;
      font-size:12px;
      text-align:center;
    }
    .list-item-pic {
      width: 47.0666667vw;
      height: 31.333333vw;
    }
    .list-item-pic img{
      width: 100%;
      height: 100%;
    }
    .votebtn {
      width: 100%;
      text-align: center;
      button {
        width: 40.266667vw;
        height: 8vw;
        background: linear-gradient(90deg, #8BACFC 0%, #3D7CFC 100%);
        border-radius: 30px;
        outline: none;
        border: none;    
        color: white;
      }
    }
  }
}
</style>